/** @jsx jsx */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { jsx, css } from "@emotion/core";
import { colors, borders, timings } from "../../theme";

export const style = css`
    font-family: Montserrat;
    font-size: 13px;
    font-weight: 700;
    line-height: 13px;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;

    cursor: pointer;
    color: ${colors.neutral0};

    border: none;
    width: 100%;
    padding: 16px 0;
}
`;

export const disabledStyle = css`
    cursor: default;
    background-color: ${colors.neutral2};
    color: ${colors.neutral4};
}
`;

export const primaryColorsStyle = css`
    background-color: ${colors.primary6};
    transition: background-color ${timings.medium};
    &:hover {
        color: ${colors.neutral0};
        background-color: ${colors.primary7};
    }
    &:active {
        color: ${colors.neutral0};
        background-color: ${colors.primary8};
    }
    &:focus {
        outline: 2px solid ${colors.primary7};
        outline-offset: -2px;
    }
`;

export const secondaryColorsStyle = css`
    color: ${colors.primary6};
    background-color: ${colors.neutral2};
    transition: background-color ${timings.medium};
    &:hover {
        color: ${colors.neutral0};
        background-color: ${colors.primary6};
    }
    &:active {
        color: ${colors.neutral0};
        background-color: ${colors.primary7};
    }
    &:focus {
        outline: 2px solid ${colors.primary6};
        outline-offset: -2px;
    }
`;

const PrimaryCTA = ({ children, disabled, ...props }) =>
    disabled ? (
        <button disabled {...props} css={[style, disabledStyle]}>
            {children}
        </button>
    ) : (
        <button {...props} css={[style, primaryColorsStyle]}>
            {children}
        </button>
    );

PrimaryCTA.propTypes = {
    disabled: PropTypes.bool,
};

export const PrimaryCTAButton = ({ children, onClick, disabled, ...props }) =>
    disabled ? (
        <button type="button" disabled {...props} css={[style, disabledStyle]}>
            Add another
        </button>
    ) : (
        <button
            type="button"
            onClick={onClick}
            {...props}
            css={[style, primaryColorsStyle]}
        >
            {children}
        </button>
    );

PrimaryCTAButton.propTypes = {
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};

export const SecondaryCTA = ({ children, disabled, ...props }) =>
    disabled ? (
        <button disabled {...props} css={[style, disabledStyle]}>
            {children}
        </button>
    ) : (
        <button {...props} css={[style, secondaryColorsStyle]}>
            {children}
        </button>
    );

PrimaryCTA.propTypes = {
    disabled: PropTypes.bool,
};

export const PrimaryCTAHyperlink = ({ children, disabled, ...props }) =>
    disabled ? (
        <div {...props} css={[style, disabledStyle]}>
            {children}
        </div>
    ) : (
        <a {...props} css={[style, primaryColorsStyle]}>
            {children}
        </a>
    );

PrimaryCTAHyperlink.propTypes = {
    disabled: PropTypes.bool,
};

export const PrimaryCTALink = ({ children, disabled, ...props }) =>
    disabled ? (
        <div {...props} css={[style, disabledStyle]}>
            {children}
        </div>
    ) : (
        <Link {...props} css={[style, primaryColorsStyle]}>
            {children}
        </Link>
    );

PrimaryCTALink.propTypes = {
    disabled: PropTypes.bool,
};

export default PrimaryCTA;
